import type { QuickStartSectionRef } from '../github.interface'
import { pickDefaultQuickStartLanguage } from '../utils/pickDefaultQuickStartLanguage'

import { resolveLanguageList } from './utils/resolveLanguageList'
import { stripNumericPathPrefix } from './utils/stripNumericPathPrefix'

/**
 * URL path segments for a quick-start article (no leading/trailing slashes).
 * Numeric order prefixes are stripped from each segment (e.g. "2-expose-backend" → "expose-backend").
 * Multi-language articles append the active language segment; single-language articles omit it.
 */
export function quickStartArticleUrlSegments(section: QuickStartSectionRef): string[] {
  const langs = resolveLanguageList(section)
  const pathParts = stripNumericPathPrefix(section.path).split('/').filter(Boolean)
  if (langs.length === 1) return pathParts
  return [...pathParts, section.defaultLanguage ?? pickDefaultQuickStartLanguage(langs)]
}

export function quickStartArticleUrlPath(section: QuickStartSectionRef): string {
  return quickStartArticleUrlSegments(section).join('/')
}
